import { useTranslation } from "react-i18next";
import {
  EducationLeftMenuList,
  ListOfSchoolOfEducationList,
} from "../utils/constants";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";

const List_of_school = () => {
  const { t } = useTranslation();
  return (
    <CommonPageUiLayer leftNavsList={EducationLeftMenuList}>
      <div className="container">
        <div className="row">
          <div className="inner-title2">
            <h3 className="fontSizeClass"> {t("List Of Schools")} </h3>
          </div>
          <div>
            <p>List of Kolkata Municipal Corporation Schools</p>
            <span>Borough No :- </span>
          </div>
          <div className="school-tab2">
            {ListOfSchoolOfEducationList.map((item, index) => (
              <DownloadFileByFileStoreId
                fileStoreId={item.fileStoreId}
                label={item.label}
              />
            ))}
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
    // <>
    //   <section id="hero" className="hero hero2">
    //     <LeftSocialMediaIconUI />

    //     <div className="carousel-item active">
    //       <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
    //       <div className="container">
    //         <div className="section-main-heading2"></div>
    //       </div>
    //     </div>
    //   </section>
    //   {/* End Slider */}

    //   <section className="section inner-pad1">
    //     <div className="container">
    //       <div className="row">
    //         <div className="col-lg-3">
    //           <div className="site-menu ">
    //             <nav className="sidebar card py-2">
    //               <ul className="nav flex-column" id="nav_accordion">
    //                 {EducationLeftMenuList.map((item, index) => (
    //                   <RenderNavItem item={item} index={index} t={t} />
    //                 ))}
    //               </ul>
    //             </nav>
    //           </div>
    //         </div>
    //         <div className="col-lg-9">
    //           <div className="container">
    //             <div className="row">
    //               <div className="inner-title2">
    //                 <h3 className="fontSizeClass"> {t("List Of Schools")} </h3>
    //               </div>
    //               {/* <div className="school-tab2 d-flex flex-wrap">
    //                 {ListOfSchoolOfEducationList.map((item, index) => (
    //                   <DownloadFileByFileStoreId
    //                     fileStoreId={item.fileStoreId}
    //                     label={item.label}
    //                     key={index}
    //                   />
    //                 ))}
    //               </div> */}
    //               <div className="school-tab2">
    //                 {ListOfSchoolOfEducationList.map((item, index) => (

    //                   // <div
    //                   //   key={index}
    //                   //   style={{
    //                   //     flex: "0 0 12.5%", // 100 / 8 = 12.5% (8 items per row)
    //                   //     maxWidth: "12.5%",
    //                   //     padding: "5px",
    //                   //   }}
    //                   // >
    //                   //   <div
    //                   //     style={{
    //                   //       backgroundColor: UiThemeBlueColor,
    //                   //       color: "#fff",
    //                   //       // padding: "10px",
    //                   //       textAlign: "center",
    //                   //       borderRadius: "4px",
    //                   //       cursor: "pointer",
    //                   //     }}
    //                   //   >
    //                       <DownloadFileByFileStoreId
    //                         fileStoreId={item.fileStoreId}
    //                         label={item.label}
    //                       />
    //                   //   </div>
    //                   // </div>
    //                 ))}
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </section>
    // </>
  );
};

export default List_of_school;
